import React from 'react';
import PropTypes from 'prop-types';

import ContentfulImage from '../../../components/ContentfulImage';

import { Wrapper, ImageWrapper, Content, Title, Description, Input, InputSubtitle, ErrorText } from './Name.style';

const NameSlide = ({ title, description, copy, image, name, onUpdateName, nameError }) => (
  <Wrapper>
    <ImageWrapper>
      <ContentfulImage
        src={image}
        options={{
          size: 350,
          objectFit: 'cover',
          w: '100%',
        }}
      />
    </ImageWrapper>
    <Content>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Input type="text" name="name" value={name} placeholder={copy.name} onChange={onUpdateName} error={nameError} />
      {nameError && <ErrorText>{copy.input_error_text}</ErrorText>}
      <InputSubtitle>{copy.input_details}</InputSubtitle>
    </Content>
  </Wrapper>
);

NameSlide.defaultProps = {
  copy: {
    name: 'Your Name',
    input_details: 'Please enter your name to proceed.',
  },
  image: null,
  title: '',
  description: '',
  nameError: false,
};

NameSlide.propTypes = {
  image: PropTypes.shape({}),
  title: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string.isRequired,
  onUpdateName: PropTypes.func.isRequired,
  copy: PropTypes.shape({
    name: PropTypes.string,
    input_details: PropTypes.string,
  }),
  nameError: PropTypes.bool,
};

export default NameSlide;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosisPage/Slides/Name.js